export default __webpack_public_path__ + "static/m-signbox1-a885a0d37ecb5322107566ace00763a9.jpg";